import React from 'react';
import type { IconProps } from '@models/types';

export const DeleteIcon: React.FC<IconProps> = ({ className }) => (
    <svg
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        className={className}
    >
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M15.874 4C15.4299 2.27477 13.8638 1 12 1C10.1362 1 8.57006 2.27477 8.12602 4H4C3.44772 4 3 4.44772 3 5C3 5.55228 3.44772 6 4 6H20C20.5523 6 21 5.55228 21 5C21 4.44772 20.5523 4 20 4H15.874ZM13.7324 4C13.3866 3.4022 12.7403 3 12 3C11.2597 3 10.6134 3.4022 10.2676 4H13.7324Z'
            fill='currentColor'
        />
        <path
            d='M4.92048 8.00317C5.47102 7.95925 5.95292 8.36994 5.99683 8.92048L6.88701 20.0795C6.92848 20.5993 7.3624 21 7.88385 21H16.1162C16.6376 21 17.0715 20.5993 17.113 20.0795L18.0032 8.92048C18.0471 8.36994 18.529 7.95925 19.0795 8.00317C19.6301 8.04708 20.0408 8.52898 19.9968 9.07952L19.1067 20.2386C18.9823 21.7979 17.6805 23 16.1162 23H7.88385C6.3195 23 5.01774 21.7979 4.89335 20.2386L4.00317 9.07952C3.95925 8.52898 4.36994 8.04708 4.92048 8.00317Z'
            fill='currentColor'
        />
        <path
            d='M14.1339 18.9978C14.6849 19.0348 15.1616 18.618 15.1985 18.067L15.6663 11.0892C15.7033 10.5382 15.2865 10.0615 14.7355 10.0246C14.1844 9.98761 13.7077 10.4044 13.6708 10.9554L13.203 17.9332C13.166 18.4842 13.5828 18.9609 14.1339 18.9978Z'
            fill='currentColor'
        />
        <path
            d='M8.85801 18.067C8.89496 18.618 9.37162 19.0348 9.92267 18.9978C10.4737 18.9609 10.8905 18.4842 10.8535 17.9332L10.3857 10.9554C10.3488 10.4044 9.87211 9.98761 9.32106 10.0246C8.77002 10.0615 8.35325 10.5382 8.3902 11.0892L8.85801 18.067Z'
            fill='currentColor'
        />
    </svg>
);
